import { render, staticRenderFns } from "./productPriceContent.vue?vue&type=template&id=618addae&scoped=true&"
import script from "./productPriceContent.vue?vue&type=script&lang=js&"
export * from "./productPriceContent.vue?vue&type=script&lang=js&"
import style0 from "./productPriceContent.vue?vue&type=style&index=0&id=618addae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618addae",
  null
  
)

export default component.exports